import React, { useState, memo } from "react";
import { useTranslation } from "react-i18next";
import { Props, State, DaysPendingQuickFilter } from "./interfaces";

import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const DaysPendingQuickfilter = <Q extends DaysPendingQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.days_pending";

  const [options] = useState<State>({
    customOptions: [],
    computedOptions: [
      {
        name: t(`${tRP}.no_days`),
        value: { days: 0 },
      },
      {
        name: t(`${tRP}.one_day`),
        value: { days: 1 },
      },
      {
        name: t(`${tRP}.five_days`),
        value: { days: 5 },
      },
      {
        name: t(`${tRP}.ten_days`),
        value: { days: 10 },
      },
      {
        name: t(`${tRP}.fifteen_days`),
        value: { days: 15 },
      },
    ],
  });

  return (
    <QuickFilter
      options={[...options.customOptions, ...options.computedOptions]}
      quickFilters={quickFilters}
      quickFilter="daysPending"
      handleChangeQuickFilter={handleChangeQuickFilters}
      defaultLabel={t(`${tRP}.default_label`)}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
      customWidth="286px"
    />
  );
};

export default memo(DaysPendingQuickfilter);
